import styled from 'styled-components';

// Displays text with formatting preserved
// TODO: support height limit, "show more" button
export default styled.div`
  white-space: pre-wrap;
  overflow-wrap: break-word;
`;
